import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import cx from "classnames"
import GridContainer from "../../components/Grid/GridContainer.jsx"
import Paper from "@material-ui/core/Paper"
import moment from "moment"
import GridItem from "../../components/Grid/GridItem.jsx"
import { noMP, cYbnd, cY, transition } from "../../assets/jss/material-dashboard-pro-react"
import uuid from "uuid/v4"

import Tooltip from "@material-ui/core/Tooltip"
import IconButton from "@material-ui/core/IconButton"
import Grow from "@material-ui/core/Grow"
import { ReactComponent as HelpIcon } from "../../assets/icons/serverside-icon-help.svg"
import { ReactComponent as CloseIcon } from "../../assets/icons/serverside-icon-close-black.svg"
import Popper from "@material-ui/core/Popper"
import "moment/locale/en-gb"
import ClickAwayListener from "@material-ui/core/ClickAwayListener"

import { componentWithContext } from "../../state/DispatchContext.js"

const styles = (theme) => ({
  noMP,
  cYbnd,
  cY,
  transition,
  reportText: {
    fontSize: 12,
    letterSpacing: 0,
    color: "#979ba0",
    marginTop: 3,
    marginLeft: 5,
    top: "10%",
    transform: "translateY(-50%)",
  },
  reportNumber: {
    fontSize: 54,
    fontWeight: 600,
    letterSpacing: 0,
    color: "#6282b3",
    marginTop: 20,
    marginLeft: 5,
    top: "40%",
    transform: "translateY(-50%)",
  },
  paper: {
    ...noMP,
  },
  reportPaper: {
    margin: 15,
    paddingTop: 31,
    paddingBottom: 37,
    paddingLeft: 40,
    paddingRight: 40,
    width: "100%",
  },
  reportHeader: {
    margin: 0,
  },
  reportNameBlock: {
    fontSize: 20,
    fontWeight: 400,
    color: "#465d80",
  },
  helpPaper: {
    backgroundColor: "#f2f4f7",
    fontSize: 12,
    maxWidth: 400,
  },
  helpTexts: {
    paddingTop: 25,
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
  },

  activeInterval: {
    backgroundColor: "#f2f4f7",
  },
})

const iconWidth = 25

const iconMarginTop = 3
const textMarginTop = 5

class CDNReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      paperId: uuid(),
      reportNameBlockId: uuid(),
      widths: [],
      helpOpen: false,
      fromDate: moment(), // Initialize to current date
      toDate: moment(), // Initialize to current date
      anchorEl: null,
      classes: props.classes,
      data: props.data,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  kbToGb(kilobytes) {
    try {
      if (!kilobytes) {
        return 0
      }
      const gigabytes = kilobytes / (1024 * 1024)
      return gigabytes.toFixed(2)
    } catch (error) {
      console.log(error)
      return 0
    }
  }

  bytesToGB(bytes, decimals = 2) {
    if (typeof bytes !== "number" || bytes < 0) {
      console.log("error : Input is not a number or it's negative")
      return 0
    }
    const gb = bytes / 1000 ** 3 // Decimal GB conversion
    return parseFloat(gb.toFixed(decimals))
  }

  handleClick = (event) => {
    const { currentTarget } = event
    this.setState({
      helpOpen: !this.state.helpOpen,
      anchorEl: currentTarget,
    })
  }

  render() {
    return (
      <Paper square={true} className={this.state.classes.reportPaper} component={"div"}>
        <div className={this.state.classes.reportHeader} style={{ width: "100%", height: 50 }}>
          <div className={this.state.classes.reportNameBlock} style={{ float: "left", marginTop: textMarginTop }}>
            <div>Ad Media CDN Egress</div>
          </div>
          <IconButton
            style={{ float: "left", padding: 0, marginLeft: 10.5, marginTop: iconMarginTop }}
            onClick={this.handleClick}
          >
            <HelpIcon style={{ width: iconWidth }} />
          </IconButton>
          <Popper
            open={this.state.helpOpen}
            anchorEl={this.state.anchorEl}
            placement="bottom-start"
            transition
            popperOptions={{
              modifiers: {
                offset: { offset: "25px, 0px" },
              },
            }}
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps} id="menu-list-grow">
                <Paper className={this.state.classes.helpPaper} square={true}>
                  <ClickAwayListener onClickAway={this.handleClick}>
                    <div>
                      <IconButton style={{ float: "right", width: 25, padding: 8 }} onClick={this.handleClick}>
                        <CloseIcon style={{ width: 25 }} />
                      </IconButton>
                      <div className={this.state.classes.helpTexts}>
                        <div>The "CDN Egress" identifies how much GB were used for ad media delivery to the CDN.</div>
                      </div>
                    </div>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
          {/* <IconButton disabled style={{ float: "right", padding: 0, marginTop: iconMarginTop }}>
            <ExportIcon style={{ width: iconWidth }} />
          </IconButton>
          <IconButton
            disabled
            style={{ float: "right", padding: 0, marginRight: 10, marginLeft: 10, marginTop: iconMarginTop }}
          >
            <FavGreyIcon style={{ width: iconWidth }} />
          </IconButton> */}
        </div>
        <GridContainer className={this.state.classes.noMP} style={{ width: "100%", height: "100%" }}>
          <GridItem className={this.state.classes.noMP} style={{ height: "100%" }}>
            <GridContainer item className={this.state.classes.noMP} style={{ height: "100%" }}>
              <GridItem
                className={cx(this.state.classes.noMP, this.state.classes.cYbnd)}
                style={{ width: "100%", height: "100%" }}
              >
                <div className={this.state.classes.reportText}>Bandwidth in GB</div>
                <Tooltip title={"bandwidth in GB"} placement={"bottom-end"} enterDelay={300}>
                  <div className={this.state.classes.reportNumber}>{this.bytesToGB(this.state.data?.bandwidth)}</div>
                </Tooltip>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </Paper>
    )
  }
}

export default componentWithContext(withStyles(styles)(CDNReport))
